import React from 'react'
import classes from './CompareEKG.css'
import EKGPreview from '../../../../components/EKGPreview'
import CloseIcon from 'static/images/close.svg'
import RecordingPreviewMetaData from '../RecordingPreviewMetaData'

export const CompareEKG = props => {
  const {
    recording,
    closePopover,
    me,
  } = props
  const {
    recordedAt,
    bpm,
    previewData,
    is6l,
  } = recording

  return (
    <div className={classes.compareEKG}>
      <div className={classes.header}>
        <h2 className={classes.previousHeader}>
          Previous ECG
        </h2>
        <button
          className={classes.closeIcon}
          onClick={() => ((typeof closePopover === 'function') ? closePopover() : undefined)}
        >
          <CloseIcon />
        </button>
      </div>
      <div className={classes.previewWrapper}>
        <EKGPreview
          previewData={previewData}
        />
      </div>
      <div className={classes.metaDataWrapper}>
        <RecordingPreviewMetaData
          bpm={bpm}
          recordedAt={recordedAt}
          is6l={is6l}
          me={me}
        />
      </div>
    </div>
  )
}

export default CompareEKG



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/CompareEKG/CompareEKG.jsx